// extracted by mini-css-extract-plugin
module.exports =  {"tag":"TagSuccess-module__tag___Tmefj"};